import GroupStore from 'groups/stores/GroupStore';
import Dialog from 'components/Dialog';
import LinkDevicePage from 'user/components/LinkDevicePage';
import { ConfirmableDeviceType } from 'entities/Device';

import * as React from 'react';

type Props = {
  onRequestHide?: () => void;
  onDone?: (authToken?: string, deviceUid?: string) => void;
  /* Skip updating device preferences:
   *
   * When adding a new device the backend
   * try to make smart choice about enabling the added device
   * and disabeling preixisting one. This skips it, the added
   * device will be disabled, and current devices will not change.
   */
  skipUpdateDevicePreferences?: boolean;
  title?: string;
  subtext?: string;
  deviceType: ConfirmableDeviceType;
};

class LinkDeviceModal extends React.Component<Props> {
  handleDone = (authToken?: string, deviceUid?: string) => {
    // we might have new subscriptions!
    GroupStore.invalidate();
    if (this.props.onRequestHide) {
      this.props.onRequestHide();
    }
    // callback from parent
    if (this.props.onDone) {
      this.props.onDone(authToken, deviceUid);
    }
  };

  render() {
    return (
      <Dialog {...this.props} box>
        <LinkDevicePage
          closable
          onDone={this.handleDone}
          onRequestHide={this.props.onRequestHide}
          skipUpdateDevicePreferences={this.props.skipUpdateDevicePreferences}
          title={this.props.title}
          subtext={this.props.subtext}
          deviceType={this.props.deviceType}
          usingMagicLink
        />
      </Dialog>
    );
  }
}

export default LinkDeviceModal;
